import React, { useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import Sidebar from '../../partials/Sidebar';
import Header from '../../partials/Header';
import Banner from '../../partials/Banner';
import PhysiciansEdit from './physiciansedit';
import { logAuditUI } from '../../utils/auditLogger';

function PhysiciansAbout() {
    const [sidebarOpen, setSidebarOpen] = useState(false);
    const location = useLocation();
    const selectedPhysician = location.state?.item;

    useEffect(() => {
        if (selectedPhysician) {
            logAuditUI({
                actionType: 'OPEN_FORM',
                module: 'Medici',
                entityType: 'physician',
                entityId: selectedPhysician.physician_id,
                entityName: selectedPhysician.user_name_surname,
                description: `A accesat profilul medicului: ${selectedPhysician.user_name_surname || selectedPhysician.physician_id}`,
                routePath: '/physicians/editphysician',
            });
        }
    }, [selectedPhysician]);

    const doctorName = selectedPhysician?.user_name_surname || "Medic";

    return (
        <div className="flex h-screen overflow-hidden bg-[#F6F7FB] dark:bg-gray-900">
            {/* Sidebar */}
            <Sidebar sidebarOpen={sidebarOpen} setSidebarOpen={setSidebarOpen} />

            {/* Content area */}
            <div className="relative flex flex-col flex-1 overflow-y-auto overflow-x-hidden">
                <Header sidebarOpen={sidebarOpen} setSidebarOpen={setSidebarOpen} />
                
                <main className="grow">
                    <div className="px-4 sm:px-8 lg:px-8 py-6 pb-9 w-full">
                        {/* Page Header matching /users/aboutuser */}
                        <div className="mb-6 flex flex-col sm:flex-row sm:items-center justify-between gap-3">
                            <div>
                                <div className="flex items-center gap-1.5 text-xs font-medium text-[#98A1B2] dark:text-gray-400 mb-1">
                                    <span>Medici</span>
                                    <span>›</span>
                                    <span className="text-[#697386] dark:text-gray-300 font-semibold">{doctorName}</span>
                                </div>
                                <h1 className="text-[24px] sm:text-[26px] font-bold text-[#172033] dark:text-gray-100 leading-tight tracking-[-0.02em]">
                                    Profilul medicului
                                </h1>
                                <p className="text-xs text-[#7B8496] dark:text-gray-400 mt-0.5">
                                    Gestionează informațiile medicului, instituțiile afiliate și produsele asociate.
                                </p>
                            </div>
                        </div>

                        {/* Content Component */}
                        <PhysiciansEdit />
                    </div>
                </main>

                <Banner />
            </div>
        </div>
    );
}

export default PhysiciansAbout;